import { render } from "./projectInfo.vue?vue&type=template&id=1ec0ed0e&scoped=true"
import script from "./projectInfo.vue?vue&type=script&lang=js"
export * from "./projectInfo.vue?vue&type=script&lang=js"

import "./projectInfo.vue?vue&type=style&index=0&id=1ec0ed0e&scoped=true&lang=css"

import exportComponent from "D:\\_2021\\项目管理系统\\TYH_office_automation\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ec0ed0e"]])

export default __exports__